module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"Confirmed":"Confirmed","SingleOptIn":"Unconfirmed","UnengagedNonMarketable":"Unengaged non-marketable","NonMarketable":"Non-marketable","Unsubscribed":"Unsubscribed","UnengagedMarketable":"Unengaged Marketable","Manual":"Opt-Out"}}')
  delete Component.options._Ctor
}
